import "./firebaseClient";
import "firebaseui/dist/firebaseui.css";

import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import ConfigProvider from "./providers/Config/Provider";
import StorageProvider from "./providers/Storage/Provider";
import GlobalConfig from "./providers/GlobalConfig/Provider";
import ListenerProvider from "./providers/Listener/Provider";
import config from "./config";

const BaseLayout = lazy(() => import("./containers/Layout/BaseLayout"));
const { components } = config;
const { Loading = () => <div /> } = components || {};

export default function SigilPortal() {
  return (
    <Suspense fallback={<Loading />}>
      <ConfigProvider appConfig={config}>
        <GlobalConfig>
          <StorageProvider>
            <ListenerProvider>
              <BrowserRouter>
                <Routes>
                  <Route
                    path="*"
                    element={
                      <Suspense fallback={<Loading />}>
                        <BaseLayout appConfig={config} />
                      </Suspense>
                    }
                  />
                </Routes>
              </BrowserRouter>
            </ListenerProvider>
          </StorageProvider>
        </GlobalConfig>
      </ConfigProvider>
    </Suspense>
  );
}
